jQuery(document).ready(function() {
  // Remove local task menu if users role does not match the url agency
  jQuery('.hide-edit-menu #block-opa-theme-local-tasks').remove();
  var submitIcon = jQuery('.sb-icon-search');
  var submitInput = jQuery('.sb-search-input');
  var searchBox = jQuery('.sb-search');
  var isOpen = false;
  jQuery(document).mouseup(function() {
    if(isOpen == true) {
      submitInput.val('');
      jQuery('.sb-search-submit').css('z-index','-999');
      submitIcon.click();
    }
  });
  submitIcon.mouseup(function() {
    return false;
  });
  searchBox.mouseup(function() {
    return false;
  });
  submitIcon.click(function() {
    if(isOpen == false) {
      searchBox.addClass('sb-search-open');
      isOpen = true;
    } else {
      searchBox.removeClass('sb-search-open');
      isOpen = false;
    }
  });
  // used for showing more
  jQuery(".show_div").hide();
      
  jQuery("#show_link").click(function() {
    jQuery(".show_div").show("slow");
    jQuery(this).remove();
  });
});

jQuery(document).ready(function locationChange() {
  //JS for the dropdown form located at /general/contact/contact-phonekeypersonnel
  var dropDownValue = jQuery("#phone-key-personnel");
  if (dropDownValue.length > 0) {
    dropDownValue.on("change", function() {
      var url = jQuery(this).val();
      if (url) {
        window.location.href = url;
      }
      return false;
    });
  }
});

// This is needed for the federal holidays modal to work
jQuery('#holidaysModal').appendTo("body");
